// Load PB Short Interest Rate
export const START_LOAD_PB_SHORT_INTEREST_RATE = 'START_LOAD_PB_SHORT_INTEREST_RATE';
export const LOAD_PB_SHORT_INTEREST_RATE_SUCCESS = 'LOAD_PB_SHORT_INTEREST_RATE_SUCCESS';
export const LOAD_PB_SHORT_INTEREST_RATE_FAILURE = 'LOAD_PB_SHORT_INTEREST_RATE_FAILURE';
export const INIT_LOAD_PB_SHORT_INTEREST_RATE_ACTION_STATUS = 'INIT_LOAD_PB_SHORT_INTEREST_RATE_ACTION_STATUS';